import { render, staticRenderFns } from "./auditorsList.vue?vue&type=template&id=edd5ead2&"
import script from "./auditorsList.vue?vue&type=script&lang=js&"
export * from "./auditorsList.vue?vue&type=script&lang=js&"
import style0 from "./auditorsList.vue?vue&type=style&index=0&id=edd5ead2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports